// extracted by mini-css-extract-plugin
export default {"header":"FBlGR","emailFromContainer":"UPI8R","emailFrom":"OB9oA","date":"NOWZo","content":"Lbmgs","tags":"A6gxu","tag":"s9nfg","tagText":"xQFZg"};